export const theads = [
  'SL No',
  'VIN',
  'Client',
  'Vehicle Name',
  'Phone',
  'Payment Method',
  'Status',
  'Delivery Date',
  'View',
];

export const columns = [
  { title: 'SL No', data: 'SL No' },
  { title: 'VIN', data: 'VIN' },
  { title: 'Client', data: 'Client' },
  { title: 'Vehicle Name', data: 'Vehicle Name' },
  { title: 'Phone', data: 'Phone' },
  { title: 'Payment Method', data: 'Payment Method' },
  { title: 'Status', data: 'Status' },
  { title: 'Delivery Date', data: 'Delivery Date' },
  {
    title: 'View',
    data: 'View',
    render: (data) => {
      return `<button type="button" class="btn btn__util view-btn" data-product-id="${data}">
        <ion-icon name="eye" class="ion-lg color-yellow"></ion-icon>
      </button>`;
    },
  },
];

export const commonDtOptions = {
  pagingType: 'simple_numbers',
  serverSide: true,
  processing: true,
  buttons: ['csv', 'print', 'excel'],
  dom: 'Blfrtip',
  ordering: false,
  columns: columns,
  lengthChange: true,
  //   scrollX: true,
  pageLength: 10,
  lengthMenu: [
    10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 120, 140, 160, 180, 200, 240, 280,
    300, 400, 500,
  ],
  language: {
    processing: '<div class="custom-loader"><div class="spinner"></div><div class="loading-text">Loading data ...</div></div>'
  },
  //   fixedColumns: {
  //     left: 4,
  //     right: 1,
  //   },
};

export const paymentType = {
  0: '--',
  1: 'Cash',
  2: 'Finance',
};
